/** @format */

import React from "react";
//import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import { ContextProvider } from "./stores/Provider";
import GlobalStyle from "./css/GlobalStyle";
import App from "./App";

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <ContextProvider>
    <GlobalStyle />
    <App />
  </ContextProvider>,
);
